import * as React from 'react';
import { observer } from 'mobx-react';
import { fromNullable } from 'maybeasy';
import {
  AlreadyTranslated,
  AlreadyTranslatedText,
  NotYetTranslatedText,
  T,
} from '../../Translations';

interface Props {
  title?: AlreadyTranslatedText | NotYetTranslatedText;
}

const Title: React.FC<Props> = ({ title }) =>
  fromNullable(title)
    .map((title) => {
      switch (title.kind) {
        case 'already-translated-text':
          return <AlreadyTranslated content={title} />;
        case 'not-yet-translated-text':
          return <T kind={title.translationKey} />;
      }
    })
    .getOrElse(() => <></>);

export default observer(Title);
